// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9 1H15V9.5H21V14H3V9.5H9V1Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M3 16H21V23H16V20H14V23H3V16Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-clear-filled')
export default class ClearFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'clear-filled',
    }
  }
}
